export default {"src":"/_next/static/media/ic-edit-cell.89efc847.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};